var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"title":_vm.title,"id":"user-details"}},[_c('document-block',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }